module.exports = __webpack_public_path__ + "static/media/future_me.ce687873.jpg";